// Jednoduchá a robustní implementace potvrzovacího dialogu pro Vue 3
import { createApp } from 'vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

// Proměnná pro sledování aktivní instance
let confirmDialogInstance = null

// Funkce pro vytvoření a připojení instance, pokud neexistuje
function ensureDialogExists() {
  if (confirmDialogInstance) {
    return confirmDialogInstance
  }

  // Vytvoříme DOM element pro montáž
  const mountEl = document.createElement('div')
  document.body.appendChild(mountEl)

  // Vytvoříme Vue aplikaci s ConfirmDialog komponentou
  const app = createApp(ConfirmDialog)
  const instance = app.mount(mountEl)

  // Uložíme referenci na instanci a funkci pro vyčištění
  confirmDialogInstance = {
    instance,
    cleanup: () => {
      app.unmount()
      mountEl.remove()
      confirmDialogInstance = null
    }
  }

  return confirmDialogInstance
}

// Exportujeme jednoduchý objekt s confirm metodou
export default {
  /**
   * Zobrazí potvrzovací dialog
   * @param {Object} options - Konfigurace dialogu
   * @param {string} [options.title='Potvrdit akci'] - Titulek dialogu
   * @param {string} [options.message='Opravdu chcete provést tuto akci?'] - Zpráva dialogu
   * @param {string} [options.confirmText='Ano'] - Text potvrzovacího tlačítka
   * @param {string} [options.cancelText='Ne'] - Text pro storno tlačítko
   * @returns {Promise<boolean>} - Promise, který se resolve na true pokud uživatel potvrdil, jinak false
   */
  confirm(options = {}) {
    const { instance, cleanup } = ensureDialogExists()

    // Vrátíme Promise, který se resolve podle akce uživatele
    return new Promise((resolve) => {
      instance.open(options)
        .then(result => {
          resolve(result)
          // Vyčistíme instanci pouze pokud není potřeba
          if (!document.body.contains(instance.$el) || !instance.$el.offsetParent) {
            cleanup()
          }
        })
        .catch(() => {
          resolve(false)
          cleanup()
        })
    })
  }
}
